import { TRANSITION_REGISTRATION_END_DATE, WTTA_START_DATE } from './roadmap.js';
const ONE_DAY_MS = 1000 * 60 * 60 * 24;
export function generateExecutiveSummary(input) {
    const { result, recommendations, companyType, now } = input;
    const monthsUntilWttaStart = monthsBetween(now, new Date(WTTA_START_DATE));
    const daysUntilTransitionDeadline = Math.max(0, Math.ceil((new Date(TRANSITION_REGISTRATION_END_DATE).getTime() - now.getTime())
        / ONE_DAY_MS));
    return {
        verdict: buildVerdict(result, companyType),
        context: buildContext({
            result,
            companyType,
            monthsUntilWttaStart,
            daysUntilTransitionDeadline,
        }),
        topActions: pickTopActions(recommendations),
        monthsUntilWttaStart,
        daysUntilTransitionDeadline,
    };
}
function buildVerdict(result, companyType) {
    const role = companyType === 'uitlener' ? 'uitlener' : 'inlener';
    switch (result.riskLevel) {
        case 'low':
            return `Als ${role} sta je er goed voor met een readiness van ${result.readinessPercentage}%. Het resterende werk is afronden en borgen.`;
        case 'medium':
            return `Als ${role} ben je op de goede weg met een readiness van ${result.readinessPercentage}%, maar er is gericht werk nodig vóór 1 januari 2027.`;
        case 'high':
            return `Als ${role} heb je een readiness van ${result.readinessPercentage}% en daarmee substantiële stappen te zetten vóór 1 januari 2027.`;
    }
}
function buildContext({ result, companyType, monthsUntilWttaStart, daysUntilTransitionDeadline, }) {
    const timeline = monthsUntilWttaStart > 0
        ? `Je hebt nog ${monthsUntilWttaStart} ${monthsUntilWttaStart === 1 ? 'maand' : 'maanden'} tot de wet in werking treedt. De aanmeldingsdeadline van het overgangsregime is ${formatDeadlineCopy(daysUntilTransitionDeadline)}.`
        : 'De wet is inmiddels van kracht. Compliance is geen voorbereiding meer maar een doorlopende verantwoordelijkheid.';
    const concerns = result.concerns.length > 0
        ? `De grootste aandachtspunten in jouw situatie zijn: ${formatConcerns(result.concerns)}.`
        : 'Er zijn geen acute zorgpunten naar voren gekomen, maar de doorlopende compliance-cyclus vraagt aandacht.';
    const role = companyType === 'uitlener' ? 'uitleners' : 'inleners';
    const closing = companyType === 'uitlener'
        ? `Wat overige ${role} doen mag je niet vertrouwen: je staat zelf voor jouw eigen toelating.`
        : `De controleplicht raakt elk contract dat je sluit met een uitlener.`;
    return `${timeline} ${concerns} ${closing}`;
}
function pickTopActions(recommendations) {
    return recommendations.slice(0, 3).map((rec) => ({
        title: rec.title,
        rationale: shortRationale(rec),
        priority: rec.priority,
    }));
}
function shortRationale(rec) {
    const cost = rec.estimatedCostMin !== undefined && rec.estimatedCostMax !== undefined
        ? ` Indicatieve kosten ${formatEuro(rec.estimatedCostMin)} tot ${formatEuro(rec.estimatedCostMax)}.`
        : '';
    return `Doorlooptijd circa ${rec.estimatedEffortDays} dagen.${cost}`;
}
function formatConcerns(concerns) {
    if (concerns.length === 1)
        return concerns[0] ?? '';
    if (concerns.length === 2)
        return `${concerns[0]} en ${concerns[1]}`;
    const head = concerns.slice(0, -1).join(', ');
    const tail = concerns[concerns.length - 1];
    return `${head} en ${tail}`;
}
function formatDeadlineCopy(daysRemaining) {
    if (daysRemaining <= 0)
        return 'verstreken';
    if (daysRemaining === 1)
        return 'morgen';
    return `over ${daysRemaining} dagen`;
}
function formatEuro(value) {
    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }).format(value);
}
function monthsBetween(from, to) {
    if (to.getTime() <= from.getTime())
        return 0;
    const years = to.getFullYear() - from.getFullYear();
    const months = to.getMonth() - from.getMonth();
    const days = to.getDate() - from.getDate();
    return Math.max(0, years * 12 + months - (days < 0 ? 1 : 0));
}
//# sourceMappingURL=executive-summary.js.map